import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    marginTop:12,
    padding:"0 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
  },
  box:{
    width: '100%',
    paddingTop:16,
    borderTop:'1px dotted #6b778c'
  },
  icon:{
    fontSize:16,
    color:'#03c'
  },
  listLabel:{
    fontSize:18,
    fontWeight:600,
    color:'#0b1323'
  },
  amount:{
    color:'#03c',
    fontWeight:600,
    fontSize:18,
    marginRight:42
  }
}));
const JourneyTripSupplierPendingBalanceCard = (props) => {
  const {trip,journey} = props;
  const classes = useStyles();
  let history = useHistory();
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorBalance ? journey.vendor.vendorBalance : null;
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box className={classes.box} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography className={classes.listLabel}>Pending Supplier Balance</Typography>
          <Typography className={classes.amount}>{numberFormat(vendorBalance)}</Typography>
        </Box>
      </Paper>
    </>
  );
}
export default JourneyTripSupplierPendingBalanceCard;